import React from 'react';
import styled from 'styled-components';
import { shape } from 'prop-types';
const HiddenSvg = styled.svg`
  visibility: hidden;
  position: fixed;
  z-index: -1;
`;

const SymbolWrapper = ({
  icons
}) => {
  return /*#__PURE__*/React.createElement(HiddenSvg, null, Object.values(icons).map(icon => {
    return /*#__PURE__*/React.createElement("symbol", {
      key: icon.name,
      id: icon.name,
      viewBox: icon.viewBox
    }, icon.path);
  }));
};

process.env.NODE_ENV !== "production" ? SymbolWrapper.propTypes = {
  icons: shape()
} : void 0;
SymbolWrapper.defaultProps = {
  icons: {}
};
export default SymbolWrapper;